import React, { useState } from 'react'
import SelectField from '../../elements/form/SelectField';
import { Switch } from '@headlessui/react';
import TextField from '../../elements/form/TextField';
import PlusIcon from '../../elements/icons/PlusIcon';
import TextareaField from '../../elements/form/TextareaField';
import TrashIcon from '../../elements/icons/TrashIcon';
import DateField from '../../elements/form/DateField';
import FormButton from '../../elements/form/FormButton';
import { useDispatch, useSelector } from 'react-redux';
import { ERROR } from '../../../store/types';
import moment from 'moment';

const UpdateStudentMedicals = ({medicals, submitMedicals}) => {
  const dispatch = useDispatch()
  const studentSelector = useSelector(state => state.students)
  const [hasAllergies, setHasAllergies] = useState(medicals?.allergies ? true : false);
  const [allergies, setAllergies] = useState(medicals?.allergies || []);

  const addAllergy = () => {
      const temp = [...allergies]
      temp.push('')
      setAllergies(temp)
  }

  const updateAllergy = (index, value) => {
      const temp = [...allergies]
      temp[index] = value
      setAllergies(temp)
  }

  const removeAllergy = (index) => {
      const temp = [...allergies]
      temp.splice(index, 1)
      setAllergies(temp)
  }
  const [bloodGroup, setBloodGroup] = useState(medicals?.bloodGroup || '');
  const [hasPreExistingConditions, setHasPreExistingConditions] = useState(medicals?.preExistingConditions?.conditions?.length > 0 ? true : false);
  const [preExistingConditions, setPreExistingConditions] = useState(medicals?.preExistingConditions?.conditions || ['']);

  const addPreExistingCondition = () => {
      const temp = [...preExistingConditions]
      temp.push('')
      setPreExistingConditions(temp)
  }

  const updatePreExistingCondition = (index, value) => {
      const temp = [...preExistingConditions]
      temp[index] = value
      setPreExistingConditions(temp)
  }

  const removePreExistingCondition = (index) => {
      const temp = [...preExistingConditions]
      temp.splice(index, 1)
      setPreExistingConditions(temp)
  }

  const [inoculations, setInoculations] = useState(medicals?.inoculations?.length > 0 ? medicals?.inoculations : [])

  const toggleInoculation = (inoculation) => {
      const temp = [...inoculations]
      if(!isInoculated(inoculation)) {
          temp.push(
              {
                  type: inoculation,
                  date: ''
              }
          )
      } else {
          const index = temp.findIndex(i => i.type === inoculation)
          temp.splice(index, 1)
      }
      setInoculations(temp)
  }

  const updateInoculationDate = (index, value) => {
      const temp = [...inoculations]
      temp[index].date = value
      setInoculations(temp)
  }

  const [additionalDetails, setAdditionalDetails] = useState('');

  const [validationErrors, setValidationErrors] = useState({});

  const validateForm = () => {
      let errors = {}
      if(!bloodGroup || bloodGroup === ''){
          errors.bloodGroup = true
      }
      if(hasAllergies) {
          allergies.forEach((allergy, allergyIndex) => {
              if(allergy === '') {
                  errors[`allergy-${allergyIndex}`] = true
              }
          })
      }
      if(hasAllergies) {
          allergies.forEach((preExisting, preExistingIndex) => {
              if(preExisting === '') {
                  errors[`condition-${preExistingIndex}`] = true
              }
          })
      }
      inoculations.forEach((inoculation, inoculationIndex) => {
          if(!inoculation.date || inoculation.data === ''){
              errors[`inoc-date-${inoculationIndex}`] = true
          }
      })
      setValidationErrors(errors)
      return errors
  }

  const pushMedicals = () => {
    if (Object.values(validateForm()).includes(true)) {
        dispatch({
            type: ERROR,
            error: {response: {data: {
                message: 'Please check the highlighted fields'
            }}}
        })
        return
    }

    const payload = {
      bloodGroup,
      allergies,
      preExistingConditions: {
          conditions: preExistingConditions,
          details: additionalDetails
      },
      inoculations
    }

    submitMedicals(payload)
  }

  // 'measles', 'dpt', 'hepatitis', 'csm', 'yellow-fever', 'other'
  const inoculationsOptions = [
    {
        label: "Measles",
        value: "measles"
    },
    {
        label: "DPT or Tetanus",
        value: "dpt"
    },
    {
        label: "Hepatitis",
        value: "hepatitis"
    },
    {
        label: "CSM",
        value: "csm"
    },
    {
        label: "Yellow Fever",
        value: "yellow-fever"
    },
  ]

  const bloodGroups = [
    {label: "A+", value: "A+"}, 
    {label:"A-", value: "A-"}, 
    {label: "B+", value: "B+"}, 
    {label: "B-", value: "B-"}, 
    {label: "O+", value: "O+"}, 
    {label: "O-", value: "O-"}, 
    {label: "AB+", value: "AB+"}, {label: "AB-", value: "AB-"}
  ]

  const isInoculated = (inoculation) => {
    const existingIndex = inoculations.findIndex(option => option.type === inoculation)

    return existingIndex > -1 ? true : false
  }

    
  return (
    <>
      <SelectField
        selectOptions={bloodGroups}
        inputLabel="Applicant's Blood Group"
        titleField="label"
        displayImage={false}
        imageField=""
        // preSelectedIndex={complexions.findIndex(item => item.value === applicationPayload.complexion)}
        preSelectedIndex={bloodGroups.findIndex(item => item.value === bloodGroup)}
        // preSelectedLabel={`value`}
        fieldId="applicant-complexion"
        hasError={validationErrors && validationErrors.complexion}
        // return id of accounts of the selected option
        returnFieldValue={(value) => {setBloodGroup(value.value)}}
      />

      <div className="w-full flex justify-between gap-x-4 mt-4 border-secondary border-opacity-50">
          <div className='w-10/12'>
            <label className="block text-sm font-medium text-gray-700 font-sofia-pro">Pre-existing Medical Conditions</label>
            <label className="text-xs text-gray-500 font-sofia-pro">Does your ward have any pre-existing medical conditions you would like to inform us about?</label>
          </div>
          <div className='w-2/12 flex flex-row-reverse'>
            <Switch
              checked={hasPreExistingConditions}
              onChange={()=>{setHasPreExistingConditions(!hasPreExistingConditions)}}
              className={`${
                  hasPreExistingConditions ? 'bg-vcm-light-purple' : 'bg-gray-400'
              } relative inline-flex items-center h-5 rounded-full w-10`}
              >
              <span className="sr-only">Has Pre-existing conditions</span>
              <span
                className={`transform transition ease-in-out duration-200 ${
                    hasPreExistingConditions ? 'translate-x-6 bg-vcm-purple' : 'translate-x-1 bg-gray-600'
                } inline-block w-3 h-3 transform rounded-full`}
              />
            </Switch>
          </div>
      </div>

      {hasPreExistingConditions && 
      <>
          {preExistingConditions.map((condition, conditionIndex) => (
              <div key={conditionIndex} className='w-full relative mb-6'>
                {conditionIndex > 0 && <div className='absolute top-0 right-0 z-50'>
                  <button onClick={()=>{removePreExistingCondition(conditionIndex)}} className='text-gray-500 transition duration-200 hover:text-red-600'><TrashIcon className={`w-5 h-5`} /></button>
                </div>}
                <div className='mt-1'>
                    <TextField
                      inputLabel="Condition" 
                      fieldId="condition-name" 
                      requiredField={true}
                      inputType="text" 
                      preloadValue={condition || ''}
                      hasError={validationErrors && validationErrors[`condition-${conditionIndex}`]} 
                      returnFieldValue={(value)=>{updatePreExistingCondition(conditionIndex, value)}}
                    />
                </div>
              </div>
          ))}

          <div className='flex flex-row-reverse w-full mt-1'>
              <button onClick={()=>{addPreExistingCondition()}} className='text-gray-300 bg-vcm-dark-gray p-2 rounded transition duration-200 hover:bg-vcm-light-purple hover:text-vcm-dark-gray text-sm flex items-center gap-x-2'>
                  <PlusIcon className={`w-5 h-5`} /> Add condition
              </button>
          </div>
      </>
      }

      {hasPreExistingConditions && <>
          <p className="text-sm text-primary mb-1 tracking-[0.2em] uppercase mt-8">Additional Details</p>

          <p className='text-sm text-primary mb-2'>Do you have any additional details about your ward's pre-existing medical conditions?</p>

          <div className='w-full my-5'>
            <TextareaField
              inputLabel="More Information" 
              fieldId="more-info" 
              requiredField={false}
              inputPlaceholder={`You can add any additional information here. Please make it as detailed as possible`}
              inputType="text" 
              preloadValue={''}
              hasError={false} 
              returnFieldValue={(value)=>{setAdditionalDetails(value)}}
            />
          </div>
      </>}

      <div className="w-full flex justify-between gap-x-4 border-secondary border-opacity-50 mt-[20px]">
          <div className='w-10/12'>
              <label className="block text-sm font-medium text-gray-700 font-sofia-pro">Allergies</label>
              <label className="text-xs text-gray-500 font-sofia-pro">Does your ward have any known allergies?</label>
          </div>
          <div className='w-2/12 flex flex-row-reverse'>
              <Switch
                  checked={hasAllergies}
                  onChange={()=>{setHasAllergies(!hasAllergies)}}
                  className={`${
                      hasAllergies ? 'bg-vcm-light-purple' : 'bg-gray-400'
                  } relative inline-flex items-center h-5 rounded-full w-10`}
                  >
                  <span className="sr-only">Has Allergies</span>
                  <span
                      className={`transform transition ease-in-out duration-200 ${
                          hasAllergies ? 'translate-x-6 bg-vcm-purple' : 'translate-x-1 bg-gray-600'
                      } inline-block w-3 h-3 transform rounded-full`}
                  />
              </Switch>
          </div>
      </div>

      {hasAllergies && 
          <>
              {allergies.map((allergy, allergyIndex) => (
                  <div key={allergyIndex} className='w-full relative mb-6'>
                      {allergyIndex > 0 && <div className='absolute top-0 right-0 z-50'>
                          <button onClick={()=>{removeAllergy(allergyIndex)}} className='text-gray-500 transition duration-200 hover:text-red-600'><TrashIcon className={`w-5 h-5`} /></button>
                      </div>}
                      <div className='mt-1'>
                          <TextField
                              inputLabel="Allergy" 
                              fieldId="allergy-name" 
                              requiredField={true}
                              inputType="text" 
                              preloadValue={allergy || ''}
                              hasError={validationErrors && validationErrors[`allergy-${allergyIndex}`]} 
                              returnFieldValue={(value)=>{updateAllergy(allergyIndex, value)}}
                          />
                      </div>
                  </div>
              ))}

              <div className='flex flex-row-reverse w-full mt-1'>
              <button onClick={()=>{addAllergy()}} className='text-gray-300 bg-vcm-dark-gray p-2 rounded transition duration-200 hover:bg-vcm-light-purple hover:text-vcm-dark-gray text-sm flex items-center gap-x-2'>
                  <PlusIcon className={`w-5 h-5`} /> Add allergy
              </button>
          </div>
          </>
      }

      <div className='w-full mt-[20px]'>
          <p className="block text-sm font-medium text-gray-700 font-sofia-pro">Inoculations</p>
          <p className="text-xs text-gray-500 font-sofia-pro">Please select every inoculation your ward has received and provide dates for each.</p>
      </div>

      {/* <div className='w-full my-4'>
          <Checkbox
              CheckboxLabel="Check this box if the applicant has any siblings currently schooling at Vaatia College Makurdi."
              checkboxToggleFunction={()=>{
                  // setHasVcmSiblings(!hasVcmSiblings)
              }} 
              // isChecked={hasVcmSiblings} 
              hasError={false} 
          />
      </div> */}

      {inoculationsOptions.map((inoculation, inoculationIndex)=>(
          <div key={inoculationIndex} className="w-full mt-[10px] pb-[10px] border-b">
              <div className="w-full flex justify-between gap-x-4 border-secondary border-opacity-50">
                  <div className='w-10/12'>
                      <label className="block text-sm font-medium text-gray-700 font-sofia-pro">{inoculation.label}</label>
                      {/* <label className="text-xs text-gray-500 font-sofia-pro">Does your ward have any known allergies?</label> */}
                  </div>
                  <div className='w-2/12 flex flex-row-reverse'>
                      <Switch
                          checked={isInoculated(inoculation.value)}
                          onChange={()=>{toggleInoculation(inoculation.value)}}
                          className={`${
                              isInoculated(inoculation.value) ? 'bg-vcm-light-purple' : 'bg-gray-400'
                          } relative inline-flex items-center h-5 rounded-full w-10`}
                          >
                          <span className="sr-only">{inoculation.label}</span>
                          <span
                              className={`transform transition ease-in-out duration-200 ${
                                  isInoculated(inoculation.value) ? 'translate-x-6 bg-vcm-purple' : 'translate-x-1 bg-gray-600'
                              } inline-block w-3 h-3 transform rounded-full`}
                          />
                      </Switch>
                  </div>
              </div>
              {isInoculated(inoculation.value) && <div className='mt-4 mb-[5px]'>
                <DateField
                  inputLabel={`Date of ${inoculation.label} inoculation`}
                  fieldId="dob" 
                  requiredField={true}
                  inputType="text" 
                  preloadValue={ moment(inoculation.date).format('YYYY-MM-DD') || ''}
                  hasError={validationErrors && validationErrors[`inoc-date-${inoculationIndex}`]} 
                  returnFieldValue={(value)=>{updateInoculationDate(inoculationIndex, new Date(value))}}
                />
              </div>}
          </div>
      ))}

      <div className='w-max mt-6 mb-4'>
          <FormButton buttonLabel={
              <span className='flex items-center justify-center gap-x-4'>
                  Submit Medical Information
              </span>
          } buttonAction={()=>{pushMedicals()}} processing={studentSelector.updatingStudent} />
      </div>
  </>
  )
}

export default UpdateStudentMedicals